import './DownloadButton.css'
import appleLogo from "../../assets/apple-logo.svg";


function DownloadButton() {
    return (
      <a
        className="download-button body-md semibold"
        aria-label="Sign in with Apple"
        href="https://apps.apple.com/app/apple-store/id1551848949?pt=122647219&ct=web_onboarding&mt=8"
        target="_blank"
      >
        <img className="apple-logo" src={appleLogo} alt="apple logo" />
        <div className="text">
          <span className="text-top">Download on the</span>
          <span className="text-main">App Store</span>
        </div>
      </a>
    );
}

export default DownloadButton
